exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wish-list-group{border:none;padding:0px;margin:20px 0 50px 0;display:table;width:100%}.wish-list-group .child-wishes{margin:30px 0 0 0;display:table-row}.wish-list-group .child-wishes .child{padding:0px}.wish-list-group .child-wishes .child-wish-heading a{color:#333}.wish-list-group a{text-decoration:none}.wish-list-group a i{color:#333}.wish-list-group a i.wish-list-check-icon{color:#009e0f}.wish-list-group a h2.wish-fulfilled{color:#999;font-size:24pt}i.wish-list-check-icon{color:#009e0f}@media screen and (max-width: 767px){.wish-list-group{margin:30px 0 40px 0}.wish-list-group .child-wishes{margin:0}.wish-list-group .child-wishes p{font-size:12pt}.wish-list-group .child-wishes .wish-body{position:relative}.wish-list-group i.far,.wish-list-group i.fa{position:absolute;right:10px;font-size:20px;top:30%;transform:translate(0, -50%)}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/ChildList/ChildListItem.scss
// module id = 639
// module chunks = 0